import React, { useState } from 'react';
import TextInput from '@components/application/input/textInput';
import PropTypes from 'prop-types';

const ContactView = ({
  contactEmail,
  contactNumber,
  nextView,
  postcode,
  updateCustomerDetails,
}) => {
  const [email, setEmail] = useState(contactEmail);
  const [phoneNumber, setPhoneNumber] = useState(contactNumber);
  const [customerPostcode, setCustomerPostcode] = useState(postcode);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!email || !phoneNumber || !customerPostcode) return;
    updateCustomerDetails({
      contact_email: email,
      contact_number: phoneNumber,
      postcode: customerPostcode,
    });
    nextView();
  };

  return (
    <div className="db-modal__content ac-animation--fade-in-from-right">
      <form>
        <section className="db-section">
          <p className="db-question">Your contact details</p>
          <div className="ch-form__group">
            <TextInput
              additionalInputClasses="ac-enquiry-form__input"
              autocomplete="postal-code"
              description="So we can find your nearest branch"
              errorMessage="Please enter your postcode."
              inputId="enquiry_postcode"
              inputName="enquiry[postcode]"
              inputType="postcode"
              labelName="Postcode"
              onChange={(e) => setCustomerPostcode(e.target.value)}
              requiresPostcodeValidation
              value={customerPostcode}
            />
          </div>
          <div className="ch-form__group">
            <TextInput
              additionalInputClasses="ac-enquiry-form__input"
              autocomplete="email"
              description="For your confirmation email"
              errorMessage="Please enter your email address."
              inputId="enquiry_contact_email"
              inputName="enquiry[contact_email]"
              inputType="email"
              labelName="Email address"
              onChange={(e) => setEmail(e.target.value)}
              requiresEmailValidation
              value={email}
            />
          </div>
          <div className="ch-form__group">
            <TextInput
              additionalInputClasses="ac-enquiry-form__input ac-enquiry-form__input--md"
              autocomplete="tel"
              description="We'll only call you to talk about your reservation."
              errorMessage="Please enter your phone number."
              inputId="enquiry_contact_number"
              inputName="enquiry[contact_number]"
              inputType="tel"
              labelName="Phone number"
              onChange={(e) => setPhoneNumber(e.target.value)}
              requiresPhoneNumberValidation
              value={phoneNumber}
            />
          </div>
        </section>
        <section className="db-section db-section--cta">
          <button
            className="ch-btn ch-btn--block ch-btn--cta"
            onClick={handleSubmit}
            type="submit"
          >
            Next: Additional Information
          </button>
        </section>
      </form>
    </div>
  );
};

export default ContactView;

ContactView.propTypes = {
  contactEmail: PropTypes.string,
  contactNumber: PropTypes.string,
  nextView: PropTypes.func,
  postcode: PropTypes.string,
  updateCustomerDetails: PropTypes.func,
};
